export default __webpack_public_path__ + "static/media/deposito.561603f2.png";